import { render, staticRenderFns } from "./CalendarShiftSelect.vue?vue&type=template&id=4b672296&"
import script from "./CalendarShiftSelect.vue?vue&type=script&lang=js&"
export * from "./CalendarShiftSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports